import { AnimatePresence, motion } from "motion/react";
import { useEffect } from "react";

import { EASE } from "@/app/lib/motion";
import { useToastStore } from "@/app/stores/use-toast-store";

export function Toast() {
  const message = useToastStore((s) => s.message);
  const kind = useToastStore((s) => s.kind);
  const hide = useToastStore((s) => s.hide);

  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(hide, 3800);
    return () => window.clearTimeout(timer);
  }, [message, hide]);

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.35, ease: EASE }}
          className={`fixed bottom-8 left-1/2 z-100 -translate-x-1/2 px-6 py-3 text-label uppercase tracking-nav ${
            kind === "error"
              ? "bg-charcoal text-ivory"
              : "bg-ivory text-charcoal border border-border"
          }`}
          role="status"
        >
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
